export const errorList: Record<string, ErrorInfoType> = {
  'Access denied': {
    errorType: 'Access denied',
    errorDescription: 'Access denied',
    errorStatus: 403,
    isAJwebAuthPluginError: false
  },
  accountNotLoggedIn: {
    errorType: 'accountNotLoggedIn',
    errorDescription: 'You are not logged in',
    errorStatus: 401,
    isAJwebAuthPluginError: true
  },
  cancellationError: {
    errorType: 'cancellationError',
    errorDescription: 'The operation was canceled',
    errorStatus: 400,
    isAJwebAuthPluginError: true
  },
  error: {
    errorType: 'error',
    errorDescription: 'An error occurred',
    errorStatus: 400,
    isAJwebAuthPluginError: false
  },
  hpid_idp_service_denied: {
    errorType: 'hpid_idp_service_denied',
    errorDescription: 'Service denied',
    errorStatus: 403,
    isAJwebAuthPluginError: false
  },
  invalid_grant: {
    errorType: 'invalid_grant',
    errorDescription: 'Invalid grant',
    errorStatus: 400,
    isAJwebAuthPluginError: false
  },
  invalidOption: {
    errorType: 'invalidOption',
    errorDescription: 'Invalid option provided',
    errorStatus: 400,
    isAJwebAuthPluginError: true
  },
  logoutRequestFailed: {
    errorType: 'logoutRequestFailed',
    errorDescription: 'Logout request failed',
    errorStatus: 400,
    isAJwebAuthPluginError: true
  },
  networkNotAllowed: {
    errorType: 'networkNotAllowed',
    errorDescription: 'Network not allowed',
    errorStatus: 403,
    isAJwebAuthPluginError: true
  },
  networkNotConnected: {
    errorType: 'networkNotConnected',
    errorDescription: 'Network not connected',
    errorStatus: 503,
    isAJwebAuthPluginError: true
  },
  server_error: {
    errorType: 'server_error',
    errorDescription: 'Server error occurred',
    errorStatus: 500,
    isAJwebAuthPluginError: false
  },
  tokenRequestFailed: {
    errorType: 'tokenRequestFailed',
    errorDescription: 'Token request failed',
    errorStatus: 400,
    isAJwebAuthPluginError: false
  },
  unknownError: {
    errorType: 'unknownError',
    errorDescription: 'An unknown error occurred',
    errorStatus: 520,
    isAJwebAuthPluginError: false
  },
  userCanceled: {
    errorType: 'userCanceled',
    errorDescription: 'User canceled the operation',
    errorStatus: 400,
    isAJwebAuthPluginError: false
  },
  user_not_logged: {
    errorType: 'user_not_logged',
    errorDescription: 'User not logged in',
    errorStatus: 401,
    isAJwebAuthPluginError: false
  },
  userInteractionNotAllowed: {
    errorType: 'userInteractionNotAllowed',
    errorDescription: 'User interaction not allowed',
    errorStatus: 403,
    isAJwebAuthPluginError: false
  }
};

interface ErrorInfoType {
  errorType: string;
  errorDescription: string;
  errorStatus: number;
  isAJwebAuthPluginError: boolean;
}

export const translationList: Record<string, string> = {
  '403': 'login.error.access-denied.title'
};

export const errorTranslation: Record<number, string> = {
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  500: 'Internal Server Error',
  503: 'Service Unavailable',
  520: 'Unknown Error'
};
